var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"title",rawName:"v-title"}],attrs:{"id":"app","data-title":"智言AI-中英文口语评测-智能语音评测技术专家"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }